<template lang="pug">
  SspLayout(area="core")
    .row.create-product-schema
      .col-md-12
        SspSaveForm(@onSubmit="save" :saveDisabled="!isValid" :saving="saving")
          .form-horizontal
            .form-group
              label.col-sm-2.control-label Name
              .col-sm-8
                input.form-control(v-model="name" type="text" placeholder="Product Metadata Schema Name")
            .form-group
              label.col-sm-2.control-label Schema Definition
              .col-sm-8
                textarea.schema-textarea.form-control(v-model="schema" type="text" placeholder="Product Metadata Schema")
</template>

<script>
import miniToastr from 'mini-toastr'
import Core from '@/service/apis/Core'

export default {
  data: () => ({
    saving: false,
    name: null,
    schema: null
  }),
  methods: {
    save() {
      this.saving = true
      Core.createProductMetadataSchema(encodeURIComponent(this.name), this.schema)
        .then(() => {
          miniToastr.success('Product schema was successfully created!')
          this.$router.push({ name: 'productMetadataSchemas' })
        })
        .catch((e) => {
          this.$emit('error', e)
        })
        .then(() => {
          this.saving = false
        })
    }
  },
  computed: {
    isValid() {
      return this.name && this.schema
    }
  }
}
</script>

<style lang="scss">
.create-product-schema {
  .schema-textarea {
    min-height: 300px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/core/configuration/productmetadataschema/CreateProductMetadataSchema.vue